import React, { useEffect } from "react";
import services from "../assets/images/services.png";
import frontend from "../assets/icon/web-1.svg";
import responsive from "../assets/icon/responsive-1.svg";
import appDev from "../assets/icon/app-1.svg";
import AOS from "aos";
import "aos/dist/aos.css";

const styles = {
  backgroundImage: "linear-gradient(#D31027, #EA384D)",
};

const bgColor = {
  backgroundColor: "#F4F4F4",
};

const icons = [
  {
    title: "Front End Development",
    src: frontend,
  },
  {
    title: "Responsive Web",
    src: responsive,
  },
  {
    title: "App Development",
    src: appDev,
  },
];

const Services = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const renderedIcon = icons.map(({ title, src }) => {
    return (
      <div className="mt-3 flex w-full px-16">
        <div className="w-2/12" style={styles}>
          <img src={src} alt="Front End Development" className="m-auto pt-2" />
        </div>
        <div className="ml-1 py-3 pl-3 shadow-md w-10/12" style={bgColor}>
          <h3 className="font-semibold text-sm">{title}</h3>
        </div>
      </div>
    );
  });

  return (
    <div
      className="font-montserrat pb-10 flex flex-col items-center lg:flex-row xl:justify-center md:flex-row"
      id="services"
      data-aos="fade-right"
    >
      <img
        src={services}
        alt="Services"
        className="lg:w-1/2 md:w-1/2 xl:w-1/3 lg:order-2"
      />
      <div className="w-full flex flex-col md:w-1/2 lg:w-1/2 xl:w-1/3 lg:order-1">
        <h3 className="text-2xl self-center font-semibold mt-1">Services</h3>
        <div className="flex flex-col items-center w-full">{renderedIcon}</div>
      </div>
    </div>
  );
};

export default Services;
